import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { notificationServices } from 'src/services';
import { notificationTypes } from '@monorepo/helpers';
import { typeNotificationsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';

type propsType = {
    cancelHandler: () => void;
    getNewNotificationsDoc: () => typeNotificationsDoc;
    options: Array<{
        changeOption: () => void;
        label: string;
        originalValue: boolean;
        value: boolean;
    }>;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    type: string;
};

export const NotificationsSpecialOptions: FC<propsType> = ({ cancelHandler, getNewNotificationsDoc, options, setRefreshCounter, type }) => {
    const dispatch = useDispatch();

    const somethingChanged: boolean = useMemo(() =>
        options.some(o => o.value !== o.originalValue)
    , [options]);

    const saveHandler = () => {
        if (!somethingChanged) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            title: 'Confirmar',
            message: `Se va a guardar el esquema actual de opciones especiales de notificaciones para ${notificationTypes.find(nt => nt.type === type)?.label}`,
            mode: 'confirm',
            execution: async () => {
                const newNotificationsDoc = getNewNotificationsDoc();
                dispatch(showLoadingModalReducer());
                const response = await notificationServices.SetOptions(newNotificationsDoc);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                setRefreshCounter(x => x + 1);
                dispatch(setValuesAndOpenAlertModalReducer({
                    title: 'Logrado',
                    message: '',
                    animation: 1,
                    mode: 'alert'
                }));
            }
        }));
    }

    return (
        <div className={'border rounded p-3 mb-5'}>
            <div className={'row'}>
                {options.map((o, i) =>
                    <div key={i} className={'mb-1'}>
                        <div className={'d-flex align-items-center bg-grey text-dark rounded pointer pt-2 px-1 mt-1'}
                            style={{ paddingBottom: '13px' }}
                            onClick={o.changeOption}
                        >
                            <input type={'checkbox'}
                                className={'form-check-input checkbox-md checkbox-red ms-2 me-3'}
                                checked={o.value}
                                onChange={() => {}}
                            />
                            <span className={'fw-bold'}>
                                {o.label}
                            </span>
                        </div>
                    </div>
                )}
            </div>
            {somethingChanged &&
                <div className={'d-flex justify-content-center mt-3 mb-2'}>
                    <button
                        className={'btn btn-general-blue me-1'}
                        onClick={saveHandler}
                    >
                        ACEPTAR CAMBIOS
                    </button>
                    <button
                        className={`btn btn-general-red ms-1`}
                        onClick={cancelHandler}
                    >
                        CANCELAR
                    </button>
                </div>
            }
        </div>
    );
}
